import { LucideIcon, LucideProps } from "lucide-react";
import { forwardRef } from "react";

const PowerOnPipelines: LucideIcon = forwardRef<SVGSVGElement, LucideProps>(
  (props, ref) => {
    return (
      <svg
        {...props}
        ref={ref}
        id="Layer_1"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 1024 1024"
      >
        <path d="M809.88,152.7H214.12c-33.78,0-61.42,27.64-61.42,61.42v595.76c0,33.78,27.64,61.42,61.42,61.42h595.76c33.78,0,61.42-27.64,61.42-61.42V214.12c0-33.78-27.64-61.42-61.42-61.42ZM648.32,483.14c-67.27,109.43-130.37,211.97-197.07,321.16-4.98,8.15-17.99,3.78-15.25-6.84,18.24-70.82,36.57-142,58.07-225.45,1.86-7.21-.98-15.56-5.29-15.56h-101.8c-9.41,0-15.28-11.56-10.56-19.04l198.6-320.07c4.83-7.78,15.33-3.12,12.49,7.5-19.22,71.87-38.62,144.41-61.16,228.69-1.93,7.22.9,15.7,5.25,15.7h108.05c10.4,0,11.65,9.08,8.69,13.9Z" />
      </svg>
    );
  },
);

PowerOnPipelines.displayName = "PowerOnPipelines";

export default PowerOnPipelines;
